<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<app-text-area-input
  [hidden]="url.toString().length != 0 || onClick !== null"
  [hint]="hint"
  [tooltipText]="tooltipText"
  [labelOverride]="labelOverride"
  [placeholder]="placeholder"
  [formInfo]="formInfo"
  [form]="formGroupOverride"
  [controlName]="controlName"
  [data-automation-id]="dataAutomationId"
  [disabled]="true"
  [readonly]="true"
  [hideLabel]="hideLabel"
  [isTime]="isTime"
  [showCharacterCount]="false"
  [minRows]="1"
  [valueOverride]="valueOverride"
></app-text-area-input>
<mat-form-field
  *ngIf="url || onClick"
  [ngClass]="{
    'read-only no-underline': readonly,
    'allow-pointer': tooltipText,
    'no-label': hideLabel
  }"
  [floatLabel]="'always'"
  class="w-100"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label }}
    <mat-icon [hidden]="!tooltipText" [matTooltip]="tooltipText" [matTooltipPosition]="'after'" [attr.aria-label]="'Tooltip: ' + tooltipText" tabindex="0">
      help
    </mat-icon>
  </mat-label>
  <input
    [hidden]="true"
    [disabled]="!readonly"
    [readonly]="readonly"
    matInput
    [attr.data-automation-id]="dataAutomationId"
    [value]="valueOverride || formControl?.value"
    tabindex="-1"
  />
  <span #linkWrapper *ngIf="url || onClick" class="mat-form-field-link-wrapper">
    <a *ngIf="url" [routerLink]="url" target="_blank" class="link--open-new" [attr.data-automation-id]="dataAutomationId">
      {{ valueOverride || formControl?.value }}
      <mat-icon>open_in_new</mat-icon>
      <span class="visually-hidden">(Link opens in a new window)</span>
    </a>
    <a href="javascript:void(0)"
      *ngIf="onClick"
      [routerLink]=""
      (click)="onClick()"
      [attr.data-automation-id]="dataAutomationId"
    >
      {{ valueOverride || formControl?.value }}
    </a>
  </span>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
